/**
* 模版
**/ 

<template>
    <div class="footer">
        <div style="color: #999; font-size: 13px;">
            上海华万通信科技有限公司&nbsp;版权所有&nbsp;
            <el-link href="https://element.eleme.io" target="_blank">
              <img src="../assets/img/police.png" width="18" style="display:inline-block;vertical-align: middle;">
              沪公网安备&nbsp;31011202009659号
            </el-link>
        </div>
    </div>
</template>

<script>
// 导出模块
export default {
  // 模块名字
  name: "footerItem",
  // 模块数据
  data() {
    //数据  
    return {};
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
  },
};
</script>
// scoped 样式只在本组件使用
<style scoped>

.footer{
    text-align: center;
    position: fixed;
    bottom: 0;
    height: 45px;
    width: 100%;
    /* background-color: #fff; */
    background-color: #f0f2f5;
    padding-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue